import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import resourcesToBackend from 'i18next-resources-to-backend';
import queryString from 'query-string';
import config from './config';

const defaultLanguage = 'zh-TW';
const SUPPORT_BROWSER_LANGUAGE =
  process.env.REACT_APP_SUPPORT_BROWSER_LANGUAGE.split(' ');

let { lang } = queryString.parse(window.location.search);
lang = lang || localStorage.getItem('i18nextLng');
localStorage.setItem(
  'i18nextLng',
  lang === 'null' || !lang ? defaultLanguage : lang,
);

i18n
  .use(
    resourcesToBackend((language, namespace, callback) => {
      import(
        /* webpackPrefetch: true */ /* webpackChunkName: "[request]" */ `../i18n/${language}/${namespace}.json`
      )
        .then(resources => {
          if (namespace === 'main') {
            document.title = resources.header.title;
          }
          callback(null, resources);
        })
        .catch(error => {
          callback(error, null);
        });
    }),
  )
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    fallbackLng: defaultLanguage,
    lng: lang,
    ns: ['main', 'momentFormat'],
    defaultNS: 'main',
    keySeparator: '.',
    interpolation: {
      escapeValue: false,
      defaultVariables: {
        BRAND_NAME: config.APP_TITLE,
      },
    },
    supportedLngs: SUPPORT_BROWSER_LANGUAGE,
    react: {
      useSuspense: true,
    },
  });

export default i18n;
